<template>
  <div class="clientCampaigns">
    <div class="pageContent">
      <div class="row">
        <div class="col-sm-3">
          <client-logo :path="client.logo"/>
        </div>
        <div class="col-sm-5">
          <heading type="h1" v-if="!loading"><router-link :to="{ path: `/client/${client.hash_id}` }">{{ client.name }}'s</router-link> Campaigns</heading>
        </div>
        <div class="col-sm-4">
          <button-cta title="confirm" class="pull-right" data-modalType="createCampaign" :onClick="onLaunchModal">
            Create Campaign
          </button-cta>
        </div>
      </div>

      <hr />

      <search-box v-model="search" name="Campaigns..." />

      <spinner v-if="loading" />

      <slot-table :data="filteredCampaigns" :columns="table.columns">

        <template slot="name" slot-scope="props">
          <span>
            <router-link :to="{ path: `/campaigns/${props.item.hash_id}` }">
              {{ props.item.name }}
            </router-link>
          </span>
        </template>

        <template slot="campaign_job_number" slot-scope="props">
          <span>
            {{ props.item.campaign_job_number }}
          </span>
        </template>

        <template slot="date_created" slot-scope="props">
          <span>{{ props.item.date_created.value | formatDate }}</span>
        </template>

        <template slot="campaign_actions" slot-scope="props">
          <button-cta title="edit" data-modalType="editCampaign" :data-modalField="props.item.name" :data-modalId="props.item.hash_id"
                      :onClick="onLaunchModal" class="btn btn-warning btn-xs">
            <i class="fa fa-pencil" aria-hidden="true"></i></button-cta>
          <button-cta title="clone" data-modalType="cloneCampaign" :data-modalId="props.item.hash_id"
                      :onClick="onLaunchModal" class="btn btn-success btn-xs">
            <i class="fa fa-clone" aria-hidden="true"></i>
          </button-cta>
          <button-cta title="confirm" data-modalType="deleteCampaign" :data-modalId="props.item.hash_id"
                      :onClick="onLaunchModal" class="btn btn-danger btn-xs">
            <i class="fa fa-trash" aria-hidden="true"></i>
          </button-cta>
        </template>

        <template slot="is_archived" slot-scope="props">
          <span v-if="props.item.is_archived" class="label label-pill label-warning">
            Archived
          </span>
          <span v-else class="label label-pill label-success">
            Active
          </span>
        </template>

      </slot-table>
    </div>
    <portal to="globalModal">
      <modal-delete-campaign :show="showModal.deleteCampaign" :campaignId="modalId" :clientId="client.hash_id" @close="toggleModal('deleteCampaign')" />
      <modal-clone-campaign :show="showModal.cloneCampaign" :campaignId="modalId" :clientId="client.hash_id" @close="toggleModal('cloneCampaign')" />
      <modal-create-campaign :show="showModal.createCampaign" @close="toggleModal('createCampaign')" />
      <modal-edit-campaign :show="showModal.editCampaign" :currentCampaign="editCampaign" :campaignId="modalId" :field="modalField" @close="toggleModal('editCampaign')" />
    </portal>

  </div>
</template>

<script>
import Heading from '@/components/Heading/heading'
import ClientLogo from '@/components/ClientLogo/client-logo'
import ButtonCta from '@/components/Button/button'
import Spinner from '@/components/SpinnerIcon/spinner'
import SlotTable from '@/components/Table/table'
import SearchBox from '@/components/SearchBox/searchbox'
import ModalDeleteCampaign from '@/components/Modal/campaigns/modal-delete-campaign'
import ModalCloneCampaign from '@/components/Modal/campaigns/modal-clone-campaign'
import ModalCreateCampaign from '@/components/Modal/campaigns/modal-create-campaign'
import ModalEditCampaign from '@/components/Modal/campaigns/modal-edit-campaign'

import {notificationMixin} from '@/mixins/notificationMixin'
import {campaignMixin} from '@/mixins/campaignMixin'
import {clientMixin} from '@/mixins/clientMixin'
import {modalMixin} from '@/mixins/modalMixin'

import { assoc, map, find, propEq } from 'ramda'

export default {
  name: 'ClientCampaigns',
  mixins: [notificationMixin, clientMixin, campaignMixin, modalMixin],
  components: {
    Heading,
    ClientLogo,
    Spinner,
    SlotTable,
    ButtonCta,
    ModalDeleteCampaign,
    ModalCreateCampaign,
    ModalEditCampaign,
    ModalCloneCampaign,
    SearchBox
  },
  created () {
    this.startLoading()
    this.getClient(this.clientId).then(() => {
      this.getClientCampaigns(this.clientId).then(() => {
        this.finishLoading()
        console.log('Campaigns loaded', this.clientCampaigns)
      }, error => {
        this.finishLoading()
        this.addNotification('danger', error)
      })
    }, error => {
      this.addNotification('danger', error)
    })
  },
  data: () => ({
    search: '',
    table: {
      columns: {
        name: 'Campaign Name',
        campaign_job_number: 'Campaign Job Number',
        creatives: 'Creatives',
        date_created: 'Date created',
        is_archived: 'Status',
        campaign_actions: ''
      }
    }
  }),
  computed: {
    editCampaign () {
      const campaign = find(propEq('hash_id', this.modalId), this.clientCampaigns)
      return campaign
    },
    filteredCampaigns () {
      // add clientActions key/value to data
      const formattedCampaigns = map(item => assoc('campaignsActions', true, item), this.clientCampaigns)
      return formattedCampaigns.filter(campaign => {
        return campaign.name.toLowerCase().includes(this.search.toLowerCase()) || campaign.campaign_job_number.toLowerCase().includes(this.search.toLowerCase())
      })
    }
  },
  methods: {}
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/client/campaigns/client-campaigns.vue